"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var AceMultipleSequenceAlignmentComponent_1 = require("./AceMultipleSequenceAlignmentComponent");
var AceQuerySequenceComponent = /*#__PURE__*/function (_AceMultipleSequenceA) {
  _inherits(AceQuerySequenceComponent, _AceMultipleSequenceA);
  function AceQuerySequenceComponent() {
    _classCallCheck(this, AceQuerySequenceComponent);
    return _possibleConstructorReturn(this, _getPrototypeOf(AceQuerySequenceComponent).apply(this, arguments));
  }
  _createClass(AceQuerySequenceComponent, [{
    key: "getText",
    value: function getText() {
      return this.props.alignment.getQuerySequence().sequence;
    }
  }]);
  return AceQuerySequenceComponent;
}(AceMultipleSequenceAlignmentComponent_1.AceMultipleSequenceAlignmentComponent);
exports.AceQuerySequenceComponent = AceQuerySequenceComponent;